"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = require("yup");
var zxcvbn = require("zxcvbn");
Yup.addMethod(Yup.string, 'isStrongPassword', function () {
    var errorMessage = 'Password is not strong enough. Try adding another word or two. Uncommon words are better.';
    return this.test('is-secure', errorMessage, function (value, _) {
        if (value && value !== '') {
            var securityCheck = zxcvbn(value);
            return securityCheck.score > 2;
        }
    });
});
exports.default = {
    password: Yup.string()
        .trim()
        .min(8, 'Your password must contain at least 8 characters.')
        .matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/, 'Password should contain at least 1 lowercase, 1 uppercase, 1 digit and a special character (!,-, etc.)')
        .matches(/^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/, 'Password contains forbidden characters!')
        .isStrongPassword()
        .required('Please enter password.'),
    confirmPassword: Yup.string()
        .required('Please enter confirm password.')
        .oneOf([Yup.ref('password')], 'Password does not match.')
};
//# sourceMappingURL=passwordValidation.js.map